export default __webpack_public_path__ + "9d228a34319d5a19c8b0f0403bb89339.jpg";